<template>
    <ui-dropdown placement="bottom-start" trigger-class="flex-1" :menu-class="menuClass" ref="dropdown"
                 @opened="opened">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>

        <template #menu="{ close }">
            <div class="p-3 overflow-y-auto w-full border-b border-gray-300 flex">
                <input v-model="innerQuery" @input="setQuery(innerQuery)"
                       ref="searchInput"
                       class="flex-grow relative rounded-md shadow-sm block w-full border text-sm focus:outline-none focus:ring-brand focus:border-brand"
                       style="margin: 0px!important;"/>
            </div>
            <div class=" p-3 max-h-64 overflow-y-auto w-full z-30">
                <div class="space-y-6" :key="resultsKey">
                    <div v-if="assemblies.length > 0">
                        <div class="ml-2 text-xs font-medium text-gray-400 mb-1">Assemblies</div>
                        <div class="space-y-1">
                            <div
                                v-for="item in assemblies"
                                class="flex items-center space-x-2 text-left w-full rounded-md px-1 py-0 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                :title="estimate.getTitle(item.item)"
                            >
                                <div class="truncate flex-1 flex flex-col">
                                    <div class="truncate w-full">
                                        <div class="truncate text-sms mx-0 pt-0.5 p-0.5">
                                            <button
                                                @mousedown="selectExistingItem(item.item, close)"
                                                class="flex truncate px-1 py-1.5 -my-0.5 border border-transparent rounded-lg text-xs w-full text-left font-medium hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-blue-500 hover:text-gray-600"
                                            >
                                                <span class="flex-1 w-full mr-1 relative truncate">
                                                    <span class="inline-block w-[16px]">
                                                    <estimate-assembly-pinger :item="item.item" :estimate="estimate"
                                                                              v-if="showPinger(item.item)"
                                                                              class="top-0 left-0"></estimate-assembly-pinger>
                                                    </span>
                                                {{ estimate.getTitle(item.item) }}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="items.length > 0">
                        <div class="ml-2 text-xs font-medium text-gray-400 mb-1">Existing Items</div>
                        <div class="space-y-1">
                            <div
                                v-for="item in items"
                                class="flex items-center space-x-2 text-left w-full rounded-md px-1 py-0 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                :title="item.description"
                            >
                                <div class="truncate flex-1 flex flex-col">
                                    <div class="truncate w-full">
                                        <div class="truncate text-sms mx-0 pt-0.5 p-0.5">
                                            <button
                                                @mousedown="selectExistingItem(item, close)"
                                                class="flex truncate px-1 py-1.5 -my-0.5 border border-transparent rounded-lg text-xs w-full text-left font-medium hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-blue-500 hover:text-gray-600"
                                            >
                                                <span class="flex-1 w-full mr-1 relative truncate">
                                                    <span
                                                        class="inline-block w-[16px] fas text-blue-600 fa-layer-group pr-1"
                                                        :class="item.bundle?'opacity-50':'opacity-0'"
                                                        style="font-size: 12px"
                                                        v-if="item.bundle"
                                                    ></span>
                                                    <span v-else class="inline-block w-[16px]">
                                                    <estimate-assembly-pinger :item="item" :estimate="estimate"
                                                                              v-if="showPinger(item)"
                                                                              class="top-0 left-0"></estimate-assembly-pinger>
                                                    </span>
                                                {{
                                                        item.reference + ' - ' + item.description + ' (' + (item.quantity ? item.quantity : '?') + ' ' + item.uom + ')'
                                                    }}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="items.length + assemblies.length === 0">
                        <div
                            class="text-gray-400 text-xs font-italic p-3 justify-center align-middle items-center flex">
                            No existing assemblies or items with build-ups found
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>

import EstimateAssemblyPinger from "../EstimateAssemblyPinger.vue";
import {Estimate} from "@models";

export default {
    components: {EstimateAssemblyPinger},
    props: {
        estimate: Object,
        item: Object,
        menuClass: String,
    },
    data() {
        return {
            innerQuery: '',
            query: '',
            items: [],
            assemblies: [],
            resultsKey: 0,
        }
    },
    computed: {},
    methods: {
        matchItem(item) {
            const query = this.query.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            return query.every((token) => {
                return (item.reference + ' ' + item.description).toLowerCase().includes(token);
            });
        },
        matchAssembly(item) {
            const query = this.query.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            return query.every((token) => {
                return (this.estimate.getTitle(item.item)).toLowerCase().includes(token);
            });
        },
        opened() {
            this.$nextTick(() => {
                setTimeout(() => this.$refs.searchInput.focus(), 50)
            })
        },
        scope(dropdownScope) {
            return {
                query: this.query,
                setQuery: this.setQuery,
                ...dropdownScope
            }
        },
        async setQuery(query) {
            this.query = query
            let options = []
            this.estimate.scopeOfWorks.forEach((section) => {
                section.tasks.forEach((task) => {
                    task.items.forEach((item) => {
                        if (item !== this.item) {
                            if ((item.materials.length || item.labour.length || item.fixedCosts.length) && this.matchItem(item)) {
                                options.push(item);
                            }
                        }
                    })
                })
            })
            this.items = options.slice(0, 50);
            let assemblies = [];
            this.estimate.collectedItems.items.forEach((value, name) => {
                if (!value.hasBundle && value.quantity > 1 && (value.item.materials.length || value.item.labour.length || value.item.fixedCosts.length) && this.matchAssembly(value)) {
                    assemblies.push({
                        key: name,
                        item: value.item,
                        items: value.items,
                        quantity: value.quantity,
                    });
                }
            })
            this.assemblies = assemblies.sort((a, b) => a.item.description.localeCompare(b.item.description)).slice(0, 50)
            this.resultsKey++
        },
        showPinger(item) {
            let m = this.estimate.collectedItems.items.get(Estimate.itemAsKey(item))
            return !item.bundle && (m && (m.quantity > 1))
        },
        selectExistingItem(item, close) {
            this.$emit('selected:existingItem', item);
            close();
        },
        close() {
            this.$refs.dropdown.close();
        }
    },
    mounted() {
        this.setQuery('')
    },
    beforeDestroy() {
        this.$refs.dropdown.close();
    }
}
</script>
